import { isEqual } from "lodash";
import { useState, useCallback, useEffect } from "react";

import { AnomalyTypeFilter } from "src/models/tna/tna-anomalies/anomaly-type/anomaly-type-filter";
import { AnomalyTypes } from "src/services/tna-anomalies/anomaly-types-api.service";
import { AnomalyTypeQuickFilter } from "./interfaces";

import { AnomalyTypeDTO } from "../../../models/tna/tna-anomalies/anomaly-type/anomaly-type-dto";

export const useAnomalyTypesQuickFilter = (allAnomalyTypesAsDefault = false /*, lsIdentifier?: string*/) => {
  const [anomalyTypes, setCurrAnomalyTypes] = useState<AnomalyTypeDTO[]>([]);

  const [quickfilterIsLoading, setQuickfilterIsLoading] = useState(true);

  const loadItemCallback = useCallback(
    async (signal: AbortSignal) => {
      setQuickfilterIsLoading(true);
      try {
        const response = await new AnomalyTypes().loadItems(
          { isAbnormalPresence: false } as AnomalyTypeFilter,
          undefined,
          undefined,
          { pageNumber: 0, pageSize: 1000 },
          undefined,
          60,
          signal
        );
        if (!response.error) {
          setCurrAnomalyTypes(response.items as AnomalyTypeDTO[]);

          setQuickFilter({
            anomalyTypes: {
              anomalyTypeIds: allAnomalyTypesAsDefault ? [] : [anomalyTypes[0]?.id],
            },
            // anomalyTypes: allAnomalyTypesAsDefault
            //   ? {
            //       anomalyTypeIds: response.items.map((type) => type.id),
            //     }
            //   : {
            //       ...(getLocalStorageValue(lsIdentifier ?? "QF_ANOMALY_TYPES")?.anomalyTypeIds?.length > 0
            //         ? {
            //             ...getLocalStorageValue(lsIdentifier ?? "QF_ANOMALY_TYPES"),
            //           }
            //         : {
            //             anomalyTypeIds: allAnomalyTypesAsDefault ? response.items.map((type) => type.id) : [],
            //           }),
            //     },
          });
        }
      } catch (error: any) {
        console.error(error);
      } finally {
        setQuickfilterIsLoading(false);
      }
    },
    [allAnomalyTypesAsDefault]
  );

  useEffect(() => {
    const abortController = new AbortController();

    loadItemCallback(abortController.signal);

    return () => {
      abortController.abort();
    };
  }, [loadItemCallback]);

  const [quickFilter, setQuickFilter] = useState<AnomalyTypeQuickFilter>({
    anomalyTypes: {
      anomalyTypeIds: allAnomalyTypesAsDefault ? [] : [anomalyTypes[0]?.id],
    },
    // anomalyTypes:
    //   getLocalStorageValue(lsIdentifier ?? "QF_ANOMALY_TYPES")?.anomalyTypeIds?.length > 0
    //     ? {
    //         ...getLocalStorageValue(lsIdentifier ?? "QF_ANOMALY_TYPES"),
    //       }
    //     : {
    //         anomalyTypeIds: allAnomalyTypesAsDefault ? anomalyTypes.map((type) => type.id) : [],
    //       },
  });

  const handleChangeQuickFilter = useCallback(
    (
      filter: keyof AnomalyTypeQuickFilter,
      value: AnomalyTypeQuickFilter["anomalyTypes"],
      allItems?: AnomalyTypeDTO[]
    ) => {
      if (isEqual(value, quickFilter[filter])) return;

      if (!isEqual(allItems, anomalyTypes) && !!allItems) setCurrAnomalyTypes(allItems);

      setQuickFilter((state) => ({ ...state, [filter]: value }));

      // localStorage.setItem(lsIdentifier ?? "QF_ANOMALY_TYPES", JSON.stringify(value));
    },
    [quickFilter, anomalyTypes]
  );

  return {
    anomalyTypesQuickFilter: quickFilter,
    setAnomalyTypesQuickFilter: handleChangeQuickFilter,
    anomalyTypeQFIsLoading: quickfilterIsLoading,
    allAnomalyTypes: anomalyTypes,
  };
};
